import domReady from '@wordpress/dom-ready';

domReady( () => {
  gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
  const $ = jQuery.noConflict();

  /* Block scripts */
  if ( document.querySelector('.header-hero.has-background-type-video') ) {
    document.querySelectorAll('.header-hero.has-background-type-video').forEach(block => {
      if ( block.closest('.header-carousel') ) {
        return;
      }

      const video = $(block).find('.header-hero__background video, .header-hero__embed');
      const overlay = block.querySelector('.header-hero__background-overlay');

      try { 
        window.localStorage.removeItem("plyr")
      } catch (e) {
        console.error( 'Could not access localStorage to remove plyr item. This may cause issues with video playback on some browsers. Error details: ', e);
      }
      
      const player = new Plyr(video.get(0), {
        controls: ['play'],
        hideControls: false,
        autoplay: true,
        muted: true,
        playsinline: true,
        iconUrl: mpfVars.svgSpritesheet,
        loop: {
          active: true
        }
      });

      if ( overlay ) {
        player.elements.container.appendChild(overlay);
      }
    });
  }
});